export const countries = [
  {
    'prefix': 86,
    'name': '中国',
    'code': 'CN',
  },
  {
    'prefix': 242,
    'name': '刚果',
    'code': 'CG'
  },
  {
    'prefix': 243,
    'name': '刚果民主共和国',
    'code': 'CD'
  },
  {
    'prefix': 383,
    'name': '科索沃',
    'code': 'XK'
  },
  {
    'prefix': 389,
    'name': '马其顿',
    'code': 'MK'
  },
  {
    'prefix': 355,
    'name': '阿尔巴尼亚',
    'code': 'AL'
  },
  {
    'prefix': 213,
    'name': '阿尔及利亚',
    'code': 'DZ'
  },
  {
    'prefix': 93,
    'name': '阿富汗',
    'code': 'AF'
  },
  {
    'prefix': 54,
    'name': '阿根廷',
    'code': 'AR'
  },
  {
    'prefix': 971,
    'name': '阿拉伯联合酋长国',
    'code': 'AE'
  },
  {
    'prefix': 297,
    'name': '阿鲁巴',
    'code': 'AW'
  },
  {
    'prefix': 968,
    'name': '阿曼',
    'code': 'OM'
  },
  {
    'prefix': 994,
    'name': '阿塞拜疆',
    'code': 'AZ'
  },
  {
    'prefix': 20,
    'name': '埃及',
    'code': 'EG'
  },
  {
    'prefix': 251,
    'name': '埃塞俄比亚',
    'code': 'ET'
  },
  {
    'prefix': 353,
    'name': '爱尔兰',
    'code': 'IE'
  },
  {
    'prefix': 372,
    'name': '爱沙尼亚',
    'code': 'EE'
  },
  {
    'prefix': 376,
    'name': '安道尔',
    'code': 'AD'
  },
  {
    'prefix': 244,
    'name': '安哥拉',
    'code': 'AO'
  },
  {
    'prefix': 1,
    'name': '安圭拉',
    'code': 'AI'
  },
  {
    'prefix': 1,
    'name': '安提瓜和巴布达',
    'code': 'AG'
  },
  {
    'prefix': 43,
    'name': '奥地利',
    'code': 'AT'
  },
  {
    'prefix': 358,
    'name': '奥兰群岛',
    'code': 'AX'
  },
  {
    'prefix': 61,
    'name': '澳大利亚',
    'code': 'AU'
  },
  {
    'prefix': 853,
    'name': '中国澳门',
    'code': 'MO'
  },
  {
    'prefix': 1,
    'name': '巴巴多斯',
    'code': 'BB'
  },
  {
    'prefix': 675,
    'name': '巴布亚新几内亚',
    'code': 'PG'
  },
  {
    'prefix': 1,
    'name': '巴哈马',
    'code': 'BS'
  },
  {
    'prefix': 92,
    'name': '巴基斯坦',
    'code': 'PK'
  },
  {
    'prefix': 595,
    'name': '巴拉圭',
    'code': 'PY'
  },
  {
    'prefix': 970,
    'name': '巴勒斯坦领土',
    'code': 'PS'
  },
  {
    'prefix': 973,
    'name': '巴林',
    'code': 'BH'
  },
  {
    'prefix': 507,
    'name': '巴拿马',
    'code': 'PA'
  },
  {
    'prefix': 55,
    'name': '巴西',
    'code': 'BR'
  },
  {
    'prefix': 375,
    'name': '白俄罗斯',
    'code': 'BY'
  },
  {
    'prefix': 1,
    'name': '百慕大',
    'code': 'BM'
  },
  {
    'prefix': 359,
    'name': '保加利亚',
    'code': 'BG'
  },
  {
    'prefix': 1,
    'name': '北马里亚纳群岛',
    'code': 'MP'
  },
  {
    'prefix': 229,
    'name': '贝宁',
    'code': 'BJ'
  },
  {
    'prefix': 32,
    'name': '比利时',
    'code': 'BE'
  },
  {
    'prefix': 354,
    'name': '冰岛',
    'code': 'IS'
  },
  {
    'prefix': 1,
    'name': '波多黎各',
    'code': 'PR'
  },
  {
    'prefix': 48,
    'name': '波兰',
    'code': 'PL'
  },
  {
    'prefix': 387,
    'name': '波斯尼亚和黑塞哥维那',
    'code': 'BA'
  },
  {
    'prefix': 591,
    'name': '玻利维亚',
    'code': 'BO'
  },
  {
    'prefix': 501,
    'name': '伯利兹',
    'code': 'BZ'
  },
  {
    'prefix': 267,
    'name': '博茨瓦纳',
    'code': 'BW'
  },
  {
    'prefix': 975,
    'name': '不丹',
    'code': 'BT'
  },
  {
    'prefix': 226,
    'name': '布基纳法索',
    'code': 'BF'
  },
  {
    'prefix': 257,
    'name': '布隆迪',
    'code': 'BI'
  },
  {
    'prefix': 240,
    'name': '赤道几内亚',
    'code': 'GQ'
  },
  {
    'prefix': 45,
    'name': '丹麦',
    'code': 'DK'
  },
  {
    'prefix': 49,
    'name': '德国',
    'code': 'DE'
  },
  {
    'prefix': 670,
    'name': '东帝汶',
    'code': 'TL'
  },
  {
    'prefix': 228,
    'name': '多哥',
    'code': 'TG'
  },
  {
    'prefix': 1,
    'name': '多米尼加',
    'code': 'DM'
  },
  {
    'prefix': 1,
    'name': '多米尼加共和国',
    'code': 'DO'
  },
  {
    'prefix': 7,
    'name': '俄罗斯',
    'code': 'RU'
  },
  {
    'prefix': 593,
    'name': '厄瓜多尔',
    'code': 'EC'
  },
  {
    'prefix': 291,
    'name': '厄立特里亚',
    'code': 'ER'
  },
  {
    'prefix': 33,
    'name': '法国',
    'code': 'FR'
  },
  {
    'prefix': 298,
    'name': '法罗群岛',
    'code': 'FO'
  },
  {
    'prefix': 689,
    'name': '法属波利尼西亚',
    'code': 'PF'
  },
  {
    'prefix': 594,
    'name': '法属圭亚那',
    'code': 'GF'
  },
  {
    'prefix': 590,
    'name': '法属圣马丁',
    'code': 'MF'
  },
  {
    'prefix': 379,
    'name': '梵蒂冈',
    'code': 'VA'
  },
  {
    'prefix': 63,
    'name': '菲律宾',
    'code': 'PH'
  },
  {
    'prefix': 679,
    'name': '斐济',
    'code': 'FJ'
  },
  {
    'prefix': 358,
    'name': '芬兰',
    'code': 'FI'
  },
  {
    'prefix': 238,
    'name': '佛得角',
    'code': 'CV'
  },
  {
    'prefix': 500,
    'name': '福克兰群岛（马尔维纳斯群岛）',
    'code': 'FK'
  },
  {
    'prefix': 220,
    'name': '冈比亚',
    'code': 'GM'
  },
  {
    'prefix': 57,
    'name': '哥伦比亚',
    'code': 'CO'
  },
  {
    'prefix': 506,
    'name': '哥斯达黎加',
    'code': 'CR'
  },
  {
    'prefix': 1,
    'name': '格林纳达',
    'code': 'GD'
  },
  {
    'prefix': 299,
    'name': '格陵兰',
    'code': 'GL'
  },
  {
    'prefix': 995,
    'name': '格鲁吉亚',
    'code': 'GE'
  },
  {
    'prefix': 44,
    'name': '根西岛',
    'code': 'GG'
  },
  {
    'prefix': 53,
    'name': '古巴',
    'code': 'CU'
  },
  {
    'prefix': 590,
    'name': '瓜德罗普岛',
    'code': 'GP'
  },
  {
    'prefix': 1,
    'name': '关岛',
    'code': 'GU'
  },
  {
    'prefix': 592,
    'name': '圭亚那',
    'code': 'GY'
  },
  {
    'prefix': 7,
    'name': '哈萨克斯坦',
    'code': 'KZ'
  },
  {
    'prefix': 509,
    'name': '海地',
    'code': 'HT'
  },
  {
    'prefix': 82,
    'name': '韩国',
    'code': 'KR'
  },
  {
    'prefix': 31,
    'name': '荷兰',
    'code': 'NL'
  },
  {
    'prefix': 599,
    'name': '荷兰加勒比',
    'code': 'BQ'
  },
  {
    'prefix': 1,
    'name': '荷属圣马丁',
    'code': 'SX'
  },
  {
    'prefix': 382,
    'name': '黑山共和国',
    'code': 'ME'
  },
  {
    'prefix': 504,
    'name': '洪都拉斯',
    'code': 'HN'
  },
  {
    'prefix': 686,
    'name': '基里巴斯',
    'code': 'KI'
  },
  {
    'prefix': 253,
    'name': '吉布提',
    'code': 'DJ'
  },
  {
    'prefix': 996,
    'name': '吉尔吉斯斯坦',
    'code': 'KG'
  },
  {
    'prefix': 224,
    'name': '几内亚',
    'code': 'GN'
  },
  {
    'prefix': 245,
    'name': '几内亚比绍',
    'code': 'GW'
  },
  {
    'prefix': 1,
    'name': '加拿大',
    'code': 'CA'
  },
  {
    'prefix': 233,
    'name': '加纳',
    'code': 'GH'
  },
  {
    'prefix': 241,
    'name': '加蓬',
    'code': 'GA'
  },
  {
    'prefix': 855,
    'name': '柬埔寨',
    'code': 'KH'
  },
  {
    'prefix': 420,
    'name': '捷克共和国',
    'code': 'CZ'
  },
  {
    'prefix': 263,
    'name': '津巴布韦',
    'code': 'ZW'
  },
  {
    'prefix': 237,
    'name': '喀麦隆',
    'code': 'CM'
  },
  {
    'prefix': 974,
    'name': '卡塔尔',
    'code': 'QA'
  },
  {
    'prefix': 1,
    'name': '开曼群岛',
    'code': 'KY'
  },
  {
    'prefix': 61,
    'name': '科科斯群岛',
    'code': 'CC'
  },
  {
    'prefix': 269,
    'name': '科摩罗',
    'code': 'KM'
  },
  {
    'prefix': 965,
    'name': '科威特',
    'code': 'KW'
  },
  {
    'prefix': 385,
    'name': '克罗地亚',
    'code': 'HR'
  },
  {
    'prefix': 254,
    'name': '肯尼亚',
    'code': 'KE'
  },
  {
    'prefix': 682,
    'name': '库克群岛',
    'code': 'CK'
  },
  {
    'prefix': 599,
    'name': '库拉索',
    'code': 'CW'
  },
  {
    'prefix': 371,
    'name': '拉脱维亚',
    'code': 'LV'
  },
  {
    'prefix': 266,
    'name': '莱索托',
    'code': 'LS'
  },
  {
    'prefix': 856,
    'name': '老挝',
    'code': 'LA'
  },
  {
    'prefix': 961,
    'name': '黎巴嫩',
    'code': 'LB'
  },
  {
    'prefix': 370,
    'name': '立陶宛',
    'code': 'LT'
  },
  {
    'prefix': 231,
    'name': '利比里亚',
    'code': 'LR'
  },
  {
    'prefix': 218,
    'name': '利比亚',
    'code': 'LY'
  },
  {
    'prefix': 423,
    'name': '列支敦士登',
    'code': 'LI'
  },
  {
    'prefix': 262,
    'name': '留尼汪',
    'code': 'RE'
  },
  {
    'prefix': 352,
    'name': '卢森堡',
    'code': 'LU'
  },
  {
    'prefix': 250,
    'name': '卢旺达',
    'code': 'RW'
  },
  {
    'prefix': 40,
    'name': '罗马尼亚',
    'code': 'RO'
  },
  {
    'prefix': 261,
    'name': '马达加斯加',
    'code': 'MG'
  },
  {
    'prefix': 960,
    'name': '马尔代夫',
    'code': 'MV'
  },
  {
    'prefix': 356,
    'name': '马耳他',
    'code': 'MT'
  },
  {
    'prefix': 265,
    'name': '马拉维',
    'code': 'MW'
  },
  {
    'prefix': 60,
    'name': '马来西亚',
    'code': 'MY'
  },
  {
    'prefix': 223,
    'name': '马里',
    'code': 'ML'
  },
  {
    'prefix': 692,
    'name': '马绍尔群岛',
    'code': 'MH'
  },
  {
    'prefix': 596,
    'name': '马提尼克',
    'code': 'MQ'
  },
  {
    'prefix': 262,
    'name': '马约特',
    'code': 'YT'
  },
  {
    'prefix': 44,
    'name': '曼岛',
    'code': 'IM'
  },
  {
    'prefix': 230,
    'name': '毛里求斯',
    'code': 'MU'
  },
  {
    'prefix': 222,
    'name': '毛里塔尼亚',
    'code': 'MR'
  },
  {
    'prefix': 1,
    'name': '美国',
    'code': 'US'
  },
  {
    'prefix': 1,
    'name': '美属萨摩亚',
    'code': 'AS'
  },
  {
    'prefix': 1,
    'name': '美属维京群岛',
    'code': 'VI'
  },
  {
    'prefix': 976,
    'name': '蒙古',
    'code': 'MN'
  },
  {
    'prefix': 1,
    'name': '蒙塞拉特',
    'code': 'MS'
  },
  {
    'prefix': 880,
    'name': '孟加拉国',
    'code': 'BD'
  },
  {
    'prefix': 51,
    'name': '秘鲁',
    'code': 'PE'
  },
  {
    'prefix': 691,
    'name': '密克罗尼西亚联邦',
    'code': 'FM'
  },
  {
    'prefix': 95,
    'name': '缅甸',
    'code': 'MM'
  },
  {
    'prefix': 373,
    'name': '摩尔多瓦',
    'code': 'MD'
  },
  {
    'prefix': 212,
    'name': '摩洛哥',
    'code': 'MA'
  },
  {
    'prefix': 377,
    'name': '摩纳哥',
    'code': 'MC'
  },
  {
    'prefix': 258,
    'name': '莫桑比克',
    'code': 'MZ'
  },
  {
    'prefix': 52,
    'name': '墨西哥',
    'code': 'MX'
  },
  {
    'prefix': 264,
    'name': '纳米比亚',
    'code': 'NA'
  },
  {
    'prefix': 27,
    'name': '南非',
    'code': 'ZA'
  },
  {
    'prefix': 500,
    'name': '南乔治亚岛和南桑威齐群岛',
    'code': 'GS'
  },
  {
    'prefix': 211,
    'name': '南苏丹',
    'code': 'SS'
  },
  {
    'prefix': 674,
    'name': '瑙鲁',
    'code': 'NR'
  },
  {
    'prefix': 505,
    'name': '尼加拉瓜',
    'code': 'NI'
  },
  {
    'prefix': 977,
    'name': '尼泊尔',
    'code': 'NP'
  },
  {
    'prefix': 227,
    'name': '尼日尔',
    'code': 'NE'
  },
  {
    'prefix': 234,
    'name': '尼日利亚',
    'code': 'NG'
  },
  {
    'prefix': 683,
    'name': '纽埃',
    'code': 'NU'
  },
  {
    'prefix': 47,
    'name': '挪威',
    'code': 'NO'
  },
  {
    'prefix': 672,
    'name': '诺福克岛',
    'code': 'NF'
  },
  {
    'prefix': 680,
    'name': '帕劳',
    'code': 'PW'
  },
  {
    'prefix': 64,
    'name': '皮特凯恩群岛',
    'code': 'PN'
  },
  {
    'prefix': 351,
    'name': '葡萄牙',
    'code': 'PT'
  },
  {
    'prefix': 81,
    'name': '日本',
    'code': 'JP'
  },
  {
    'prefix': 46,
    'name': '瑞典',
    'code': 'SE'
  },
  {
    'prefix': 41,
    'name': '瑞士',
    'code': 'CH'
  },
  {
    'prefix': 503,
    'name': '萨尔瓦多',
    'code': 'SV'
  },
  {
    'prefix': 685,
    'name': '萨摩亚',
    'code': 'WS'
  },
  {
    'prefix': 381,
    'name': '塞尔维亚',
    'code': 'RS'
  },
  {
    'prefix': 232,
    'name': '塞拉利昂',
    'code': 'SL'
  },
  {
    'prefix': 221,
    'name': '塞内加尔',
    'code': 'SN'
  },
  {
    'prefix': 357,
    'name': '塞浦路斯',
    'code': 'CY'
  },
  {
    'prefix': 248,
    'name': '塞舌尔',
    'code': 'SC'
  },
  {
    'prefix': 966,
    'name': '沙特阿拉伯',
    'code': 'SA'
  },
  {
    'prefix': 590,
    'name': '圣巴泰勒米',
    'code': 'BL'
  },
  {
    'prefix': 61,
    'name': '圣诞岛',
    'code': 'CX'
  },
  {
    'prefix': 239,
    'name': '圣多美和普林西比',
    'code': 'ST'
  },
  {
    'prefix': 290,
    'name': '圣赫勒拿',
    'code': 'SH'
  },
  {
    'prefix': 1,
    'name': '圣基茨和尼维斯',
    'code': 'KN'
  },
  {
    'prefix': 1,
    'name': '圣卢西亚',
    'code': 'LC'
  },
  {
    'prefix': 378,
    'name': '圣马力诺',
    'code': 'SM'
  },
  {
    'prefix': 508,
    'name': '圣皮埃尔和密克隆群岛',
    'code': 'PM'
  },
  {
    'prefix': 1,
    'name': '圣文森特和格林纳丁斯',
    'code': 'VC'
  },
  {
    'prefix': 94,
    'name': '斯里兰卡',
    'code': 'LK'
  },
  {
    'prefix': 421,
    'name': '斯洛伐克',
    'code': 'SK'
  },
  {
    'prefix': 386,
    'name': '斯洛文尼亚',
    'code': 'SI'
  },
  {
    'prefix': 47,
    'name': '斯瓦尔巴特和扬马延',
    'code': 'SJ'
  },
  {
    'prefix': 268,
    'name': '斯威士兰',
    'code': 'SZ'
  },
  {
    'prefix': 597,
    'name': '苏里南',
    'code': 'SR'
  },
  {
    'prefix': 677,
    'name': '所罗门群岛',
    'code': 'SB'
  },
  {
    'prefix': 252,
    'name': '索马里',
    'code': 'SO'
  },
  {
    'prefix': 992,
    'name': '塔吉克斯坦',
    'code': 'TJ'
  },
  {
    'prefix': 886,
    'name': '中国台湾',
    'code': 'TW'
  },
  {
    'prefix': 66,
    'name': '泰国',
    'code': 'TH'
  },
  {
    'prefix': 255,
    'name': '坦桑尼亚',
    'code': 'TZ'
  },
  {
    'prefix': 676,
    'name': '汤加',
    'code': 'TO'
  },
  {
    'prefix': 1,
    'name': '特克斯和凯科斯群岛',
    'code': 'TC'
  },
  {
    'prefix': 1,
    'name': '特立尼达和多巴哥',
    'code': 'TT'
  },
  {
    'prefix': 216,
    'name': '突尼西亞',
    'code': 'TN'
  },
  {
    'prefix': 688,
    'name': '图瓦卢',
    'code': 'TV'
  },
  {
    'prefix': 90,
    'name': '土耳其',
    'code': 'TR'
  },
  {
    'prefix': 993,
    'name': '土库曼斯坦',
    'code': 'TM'
  },
  {
    'prefix': 690,
    'name': '托克劳',
    'code': 'TK'
  },
  {
    'prefix': 681,
    'name': '瓦利斯和富图纳',
    'code': 'WF'
  },
  {
    'prefix': 678,
    'name': '瓦努阿图',
    'code': 'VU'
  },
  {
    'prefix': 502,
    'name': '危地马拉',
    'code': 'GT'
  },
  {
    'prefix': 58,
    'name': '委内瑞拉',
    'code': 'VE'
  },
  {
    'prefix': 673,
    'name': '文莱',
    'code': 'BN'
  },
  {
    'prefix': 256,
    'name': '乌干达',
    'code': 'UG'
  },
  {
    'prefix': 380,
    'name': '乌克兰',
    'code': 'UA'
  },
  {
    'prefix': 598,
    'name': '乌拉圭',
    'code': 'UY'
  },
  {
    'prefix': 998,
    'name': '乌兹别克斯坦',
    'code': 'UZ'
  },
  {
    'prefix': 30,
    'name': '希腊',
    'code': 'GR'
  },
  {
    'prefix': 34,
    'name': '西班牙',
    'code': 'ES'
  },
  {
    'prefix': 212,
    'name': '西撒哈拉',
    'code': 'EH'
  },
  {
    'prefix': 852,
    'name': '中国香港',
    'code': 'HK'
  },
  {
    'prefix': 225,
    'name': '象牙海岸',
    'code': 'CI'
  },
  {
    'prefix': 65,
    'name': '新加坡',
    'code': 'SG'
  },
  {
    'prefix': 687,
    'name': '新喀里多尼亚',
    'code': 'NC'
  },
  {
    'prefix': 64,
    'name': '新西兰',
    'code': 'NZ'
  },
  {
    'prefix': 36,
    'name': '匈牙利',
    'code': 'HU'
  },
  {
    'prefix': 1,
    'name': '牙买加',
    'code': 'JM'
  },
  {
    'prefix': 374,
    'name': '亚美尼亚',
    'code': 'AM'
  },
  {
    'prefix': 967,
    'name': '也门',
    'code': 'YE'
  },
  {
    'prefix': 964,
    'name': '伊拉克',
    'code': 'IQ'
  },
  {
    'prefix': 972,
    'name': '以色列',
    'code': 'IL'
  },
  {
    'prefix': 39,
    'name': '意大利',
    'code': 'IT'
  },
  {
    'prefix': 91,
    'name': '印度',
    'code': 'IN'
  },
  {
    'prefix': 62,
    'name': '印度尼西亚',
    'code': 'ID'
  },
  {
    'prefix': 44,
    'name': '英国',
    'code': 'GB'
  },
  {
    'prefix': 1,
    'name': '英属维京群岛',
    'code': 'VG'
  },
  {
    'prefix': 246,
    'name': '英属印度洋领地',
    'code': 'IO'
  },
  {
    'prefix': 962,
    'name': '约旦',
    'code': 'JO'
  },
  {
    'prefix': 84,
    'name': '越南',
    'code': 'VN'
  },
  {
    'prefix': 260,
    'name': '赞比亚',
    'code': 'ZM'
  },
  {
    'prefix': 44,
    'name': '泽西岛',
    'code': 'JE'
  },
  {
    'prefix': 235,
    'name': '乍得',
    'code': 'TD'
  },
  {
    'prefix': 350,
    'name': '直布罗陀',
    'code': 'GI'
  },
  {
    'prefix': 56,
    'name': '智利',
    'code': 'CL'
  },
  {
    'prefix': 236,
    'name': '中非共和国',
    'code': 'CF'
  }
];
